module.exports = __webpack_public_path__ + "img/title-page-img.e86a5dd9.png";